import { Map,Record } from "immutable";

import createFromJS from "../../createFromJS";

export const StandardItemRecord = Record({
  id: null,
  type: null,
  label: null,
  start: null,
  end: null,
  ongoing: false,
  latestStart: null,
  earliestEnd: null,
  super: null,
  propertyValues: Map(),
  locationUri: null
});

const data = {
  objects: {
    propertyValues: "Map"
  }
};

createFromJS.registerCallback("StandardItemRecord", createFromJS.createNestedCallback(StandardItemRecord, data));
